module.exports = __webpack_public_path__ + "static/fonts/eiconfont.6dc557f1.woff";